const languageList = [
    
    { "name": "简体中文", "code": "zh-CHS" },
    { "name": "繁体中文", "code": "zh-CHT" },
    { "name": "英语", "code": "en" },
    { "name": "法语", "code": "fr" },
    { "name": "日语", "code": "ja" },
    { "name": "德语", "code": "de" },
    { "name": "韩语", "code": "ko" },
    { "name": "俄语", "code": "ru" },
    { "name": "泰语", "code": "th" },
    { "name": "老挝语", "code": "lo" },
    { "name": "阿拉伯语", "code": "ar" },
    { "name": "西班牙语", "code": "es" },
    { "name": "印地语", "code": "hi" },
    { "name": "印度尼西亚语", "code": "id" },
    { "name": "意大利语", "code": "it" },
    { "name": "荷兰语", "code": "nl" },
    { "name": "葡萄牙语", "code": "pt" },
    { "name": "越南语", "code": "vi" },
    { "name": "南非荷兰语", "code": "af" },
    { "name": "阿姆哈拉语", "code": "am" },
    { "name": "阿塞拜疆语", "code": "az" },
    { "name": "白俄罗斯语", "code": "be" },
    { "name": "保加利亚语", "code": "bg" },
    { "name": "孟加拉语", "code": "bn" },
    { "name": "波斯尼亚语", "code": "bs" },
    { "name": "加泰隆语", "code": "ca" },
    { "name": "宿务语", "code": "ceb" },
    { "name": "科西嘉语", "code": "co" },
    { "name": "捷克语", "code": "cs" },
    { "name": "威尔士语", "code": "cy" },
    { "name": "丹麦语", "code": "da" },
    { "name": "希腊语", "code": "el" },
    { "name": "世界语", "code": "eo" },
    { "name": "爱沙尼亚语", "code": "et" },
    { "name": "巴斯克语", "code": "eu" },
    { "name": "波斯语", "code": "fa" },
    { "name": "芬兰语", "code": "fi" },
    { "name": "斐济语", "code": "fj" },
    { "name": "弗里西语", "code": "fy" },
    { "name": "爱尔兰语", "code": "ga" },
    { "name": "苏格兰盖尔语", "code": "gd" },
    { "name": "加利西亚语", "code": "gl" },
    { "name": "古吉拉特语", "code": "gu" },
    { "name": "豪萨语", "code": "ha" },
    { "name": "夏威夷语", "code": "haw" },
    { "name": "希伯来语", "code": "he" },
    { "name": "印地语", "code": "hi" },
    { "name": "克罗地亚语", "code": "hr" },
    { "name": "海地克里奥尔语", "code": "ht" },
    { "name": "匈牙利语", "code": "hu" },
    { "name": "亚美尼亚语", "code": "hy" },
    { "name": "伊博语", "code": "ig" },
    { "name": "冰岛语", "code": "is" },
    { "name": "爪哇语", "code": "jw" },
    { "name": "格鲁吉亚语", "code": "ka" },
    { "name": "哈萨克语", "code": "kk" },
    { "name": "高棉语", "code": "km" },
    { "name": "卡纳达语", "code": "kn" },
    { "name": "库尔德语", "code": "ku" },
    { "name": "柯尔克孜语", "code": "ky" },
    { "name": "拉丁语", "code": "la" },
    { "name": "卢森堡语", "code": "lb" },
    { "name": "立陶宛语", "code": "lt" },
    { "name": "拉脱维亚语", "code": "lv" },
    { "name": "马尔加什语", "code": "mg" },
    { "name": "毛利语", "code": "mi" },
    { "name": "马其顿语", "code": "mk" },
    { "name": "马拉雅拉姆语", "code": "ml" },
    { "name": "蒙古语", "code": "mn" },
    { "name": "马拉地语", "code": "mr" },
    { "name": "马来语", "code": "ms" },
    { "name": "马耳他语", "code": "mt" },
    { "name": "白苗语", "code": "mww" },
    { "name": "缅甸语", "code": "my" },
    { "name": "尼泊尔语", "code": "ne" },
    { "name": "荷兰语", "code": "nl" },
    { "name": "挪威语", "code": "no" },
    { "name": "齐切瓦语", "code": "ny" },
    { "name": "克雷塔罗奥托米语", "code": "otq" },
    { "name": "旁遮普语", "code": "pa" },
    { "name": "波兰语", "code": "pl" },
    { "name": "普什图语", "code": "ps" },
    { "name": "罗马尼亚语", "code": "ro" },
    { "name": "信德语", "code": "sd" },
    { "name": "僧伽罗语", "code": "si" },
    { "name": "斯洛伐克语", "code": "sk" },
    { "name": "斯洛文尼亚语", "code": "sl" },
    { "name": "萨摩亚语", "code": "sm" },
    { "name": "修纳语", "code": "sn" },
    { "name": "索马里语", "code": "so" },
    { "name": "阿尔巴尼亚语", "code": "sq" },
    { "name": "塞尔维亚语(西里尔文)", "code": "sr-Cyrl" },
    { "name": "塞尔维亚语(拉丁文)", "code": "sr-Latn" },
    { "name": "塞索托语", "code": "st" },
    { "name": "巽他语", "code": "su" },
    { "name": "瑞典语", "code": "sv" },
    { "name": "斯瓦希里语", "code": "sw" },
    { "name": "泰米尔语", "code": "ta" },
    { "name": "泰卢固语", "code": "te" },
    { "name": "塔吉克语", "code": "tg" },
    { "name": "菲律宾语", "code": "tl" },
    { "name": "克林贡语", "code": "tlh" },
    { "name": "汤加语", "code": "to" },
    { "name": "土耳其语", "code": "tr" },
    { "name": "塔希提语", "code": "ty" },
    { "name": "乌克兰语", "code": "uk" },
    { "name": "乌尔都语", "code": "ur" },
    { "name": "乌兹别克语", "code": "uz" },
    { "name": "南非科萨语", "code": "xh" },
    { "name": "意第绪语", "code": "yi" },
    { "name": "约鲁巴语", "code": "yo" },
    { "name": "尤卡坦玛雅语", "code": "yua" },
    { "name": "粤语", "code": "yue" },
    { "name": "南非祖鲁语", "code": "zu" }];

const langNameByCode = languageList.reduce((map, item) => {
  if (!map.has(item.code)) {
    map.set(item.code, item.name);
  }
  return map;
}, new Map());

function getLangNameByCode(code) {
  if (!code || code === 'auto') return '';
  if (langNameByCode.has(code)) return langNameByCode.get(code);

  const normalized = code.split('-')[0];
  if (langNameByCode.has(normalized)) return langNameByCode.get(normalized);

  const matched = languageList.find(
    (item) => item.code.split('-')[0] === normalized
  );
  return matched?.name || normalized || '目标语言';
}

export default {
  languageList,
  getLangNameByCode,
};